import classNames from 'classnames';
import React from 'react';
type Props = {
  totalSteps: number;
  currentStep: number;
};

export const StepperLine: React.FC<Props> = ({ totalSteps, currentStep }) => {
  return (
    <div className="stepper_line__container">
      {[...Array(totalSteps)].map((e, i) => (
        <div
          className={classNames('stepper_line__container__step', {
            'stepper_line__container__step--active': i === currentStep,
            'stepper_line__container__step--prev': i < currentStep,
          })}
          key={i}
        >
          <div className="stepper_line__container__step__dot"></div>
          <div className="stepper_line__container__step__number">{i + 1}</div>
          <div className="stepper_line__container__step__line"></div>
        </div>
      ))}
    </div>
  );
};
